import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useChapterState from '@/store/modules/useChapterState';
import gsap from 'gsap';
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroLoadingLight',
  setup(__props) {

const { state } = useChapterState();
const light = ref<HTMLElement | null>(null);

onMounted(() => {
  blink();
})

onBeforeUnmount(() => {
  if (timeline) timeline.kill();
})

let timeline: gsap.core.Timeline | null = null;
const durations = [0.3, 0.2, 0.2, 0.5, 0.7, 0.3, 0.6, 0.4];
const opacities = [0.3, 0.5, 0, 0.4, 0.6];
let loop = 0;
const blink = () => {
  const duration = durations[loop % durations.length];
  const opacity = opacities[loop % opacities.length];
  loop++;
  timeline = gsap.timeline({ onComplete: blink })
    .to(
      light.value,
      {
        opacity: opacity,
        duration,
        ease: 'power1.in',
      }
    )
    .to(
      light.value,
      {
        opacity: 1,
        duration,
        ease: 'power1.out',
      }
    )
}
watch(() => state.isLoading, (isLoading) => {
  if (!isLoading) {
    if (timeline) timeline.kill();
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Light", { 'show': _unref(state).showLoadingLight && _unref(state).loadProgress > 0 && _unref(state).loadProgress < 80 }])
  }, [
    _createElementVNode("div", {
      class: "Light__Inner",
      ref_key: "light",
      ref: light
    }, null, 512)
  ], 2))
}
}

})